import * as amplitude from "@amplitude/analytics-browser";

export function initAmplitude() {
    amplitude.init(process.env.AMPLITUDE_API_KEY, {
        autocapture: {
            pageViews: false,
            sessions: true,
            attribution: false,
            formInteractions: false,
            fileDownloads: false,
            elementInteractions: false,
        }
    });
}

export function trackBookingEvent(name, showtime, additional_properties = {}, force_flush = false) {
    const properties = {
        showtime_id: showtime.id,
        showtime_time: showtime.time,
        cinema_id: showtime.cinema.id,
        cinema_name: showtime.cinema.name,
        movie_id: showtime.movie.id,
        movie_name: showtime.movie.name
    };
    const event_properties = {
        ...properties,
        ...additional_properties
    };
    const event = {
        event_type: name,
        event_properties
    };

    amplitude.track(event);

    if (force_flush) {
        amplitude.flush()
    }
}

export function trackVoucherEvent(name, cineplex, additional_properties = {}, force_flush = false) {
    const properties = {
        cineplex_id: cineplex.id,
        cineplex_name: cineplex.name,
    };
    const event_properties = {
        ...properties,
        ...additional_properties
    };
    const event = {
        event_type: name,
        event_properties
    };

    amplitude.track(event)

    if (force_flush) {
        amplitude.flush()
    }
}
